const desc = `<p class="c4" dir="rtl">
  <span class="c2"
    >זכרונות (במלאת  שלשים ימי-אבל אחרי מות נחמה פוחצ&#39;בסקי ז"ל) </span
  ><span class="c1 bold">בוסתנאי</span
  ><span class="c2">  י"ד תמוז תרצ"ד  [1934 06 27]</span>
</p>`;

export default desc;
